import Popover from '@sophocles/components/Popover/Popover';

export default Popover;
